import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, AppDispatch } from '../../app/store'
import TableIcon from '../../assets/images/Table.svg'
import { ChevronLeft, ChevronRight, X } from 'lucide-react'
import { clearSelectedTable } from '../../features/tables/tablesSlice'

interface TableSelectorProps {
  onTableSelect?: () => void
}

const TableSelector: React.FC<TableSelectorProps> = ({
  onTableSelect
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const { settings } = useSelector((state: RootState) => state.settings)
  const selectedTable = useSelector((state: RootState) => {
    const selectedTableId = state.tables.selectedTable
    if (selectedTableId > 0) {
      return state.tables.tables.find(table => table.id === selectedTableId) || null
    }
    return null
  })

  const handleClearTable = async (e: React.MouseEvent) => {
    e.stopPropagation() // Prevent opening the modal when clicking X
    try {
      await dispatch(clearSelectedTable() as any)
    } catch (error) {
    }
  }

  return (
    <div 
      onClick={onTableSelect}
      className="self-stretch h-14 pl-3 pr-4 bg-white rounded-xl inline-flex justify-between items-center gap-2 overflow-hidden cursor-pointer"
    >
      <div className="flex flex-row gap-3 items-center justify-start flex-1 min-w-0">
        <img 
          src={TableIcon} 
          alt="table" 
          className="w-5 h-6 items-center justify-center flex-shrink-0"
        />
        <div className="text-text-primary text-sm font-medium font-['IBM_Plex_Sans_Arabic'] truncate">
          {selectedTable 
            ? selectedTable.name || selectedTable.number || `Table ${selectedTable.id}`
            : t('table.choose_table')
          }
        </div>
      </div>
      
      <div className="flex items-center gap-2 flex-shrink-0">
        {selectedTable ? (
          <button
            onClick={handleClearTable}
            className="h-8 w-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
            aria-label={t('common.remove') || 'Remove table'}
          >
            <X className="w-4 h-4 text-gray-600" />
          </button>
        ) : (
          settings.language === 'ar' ? (
            <ChevronLeft className="w-5 h-5 text-[#525866]" />
          ) : (
            <ChevronRight className="w-5 h-5 text-[#525866]" />
          )
        )}
      </div>
    </div>
  )
}

export default TableSelector

